import { Form, Input, Row, Col, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../universal/getList';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebEditUniversalShow = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const ref = useRef<any>(undefined);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const [countryOrAreaData, setCountryOrAreaData] = useState<any>();
    /** 后端数据defaultService */
    let defaultService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
            ref.current.row.then(async (res: any) => {
                if (typeof res !== 'undefined') {
                    if (res.success === true) {
                        const countryOrAreaCode = res.data.countryOrAreaCode;
                        fetchApi.GET(defaultService,
                            {
                                apiId: 'webCountryOrArea',
                                apiVariable: countryOrAreaCode
                            }).then(res => {
                                if (res.success) {
                                    setCountryOrAreaData([res.data]);
                                }
                            })
                    }
                }
            })
        }
        // const fetchData = async () => {
        // }
        // fetchData();
    }, []);

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'webProvince',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '省'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={6}>
                            <Form.Item
                                label="代码"
                                name="code">
                                <Input disabled={data.type === 'NEW' ? false : true} />
                            </Form.Item>
                        </Col>

                        <Col span={9}>
                            <Form.Item
                                label="名称"
                                name="provinceName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={9}>
                            <Form.Item
                                label="usName"
                                name="usName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={18}>
                            <Form.Item
                                label="国家或地区"
                                name="countryOrAreaCode">
                                <Select
                                    showSearch
                                    placeholder="区域类型"
                                    optionFilterProp="children"
                                    onSearch={(e) => getList.search('webCountryOrArea', setCountryOrAreaData, e)}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(countryOrAreaData, 'countryOrAreaName', 'code')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebEditUniversalShow;